var React = require('react');

function QuotationInline (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"className":"st0","d":"M10.4,0L0,31.1V57h26V31.1H15.6L26,0H10.4z M24,33.1V55H2V31.4L11.8,2h11.4L12.8,33.1H24z","key":0}),React.createElement("path",{"className":"st0","d":"M58,0H42.4L32,31.1V57h26V31.1H47.6L58,0z M56,33.1V55H34V31.4L43.8,2h11.4L44.8,33.1H56z","key":1})]));
}

QuotationInline.defaultProps = {"version":"1.1","id":"Warstwa_1","x":"0px","y":"0px","viewBox":"0 0 58 57","style":{"enableBackground":"new 0 0 58 57"},"xmlSpace":"preserve"};

module.exports = QuotationInline;

QuotationInline.default = QuotationInline;
